/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useRef, useState,useCallback } from 'react';
import { useSelector } from 'react-redux'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import CustomOverLay from '../../CustomOverlay'
import ManageRoles from '../../RolesSelection';
import Input from '../../InputBox';
import { validateEmail } from '../../../CommonMethods/EmailValidator';
import GlobalContext from '../../Context/GloablContext';
import Loader from '../../Loader';
import { dataService } from '../../../services/data.services';
import { pushOrRemoveElement } from '../../../CommonMethods/pushOrRemoveElement';
import CardHeader from '../../CardHeader';
import { CognitoCurrentData } from '../../../CommonMethods/CognitoData';
import { compareArrays } from '../../CompareArrays';
import authSlice from '../../../pages/auth/authSlice';
import Toast from '../../Toast';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';

const AddUser = ({edit, userType}) => { 
    const urlParams = new URLSearchParams(window.location.search);
    const {email_address,id}=useParams()
    const {MandatoryErrorMessage,setMandatoryErrorMessage,setToastmessage,isSideNavBar}=useContext(GlobalContext)
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [typeDropdown, setTypedropdown] = useState(false)
    const navigate = useNavigate()
    const location = useLocation();
    const { state: myRedirection } = location;
    const [editData, seteditData] = useState({})
    // const {userType}=useSelector(state => state.auth);

    const [loading, setloading] = useState(false);
    const [customError, setcustomError] = useState([])
    const initialState={
        "first_name": "",
        "mobile_number": "",
        "email_address": "",
        "last_name": "",
        employee_number:'',
        "user_type": userType,
        "institution_id": "",
        "roles": [],
        "staff_type": "",
    }

    const outsideClickRef = useRef()

    useOnClickOutside(outsideClickRef, () => {
        setTypedropdown(false)

    });

    const handleFetch =useCallback(
        async() => {
            try{
                const branchId = await GetBranchId()
                let response = await dataService.GetAPI(`users/${email_address}`);
                if(response.data.status===200){
                    const Getdata=response.data.data.data
                    console.log("Getdata", Getdata)
                    let rolesArray = Getdata.roles || [];
                    const anyCollectFeeRoleExists = rolesArray.some(role => role.startsWith("collect-fee"));
                    if((rolesArray.includes("collect-fee") && !anyCollectFeeRoleExists) ||
                        rolesArray.includes("collect-fee") && rolesArray.includes("collect-fee:receipt")){
                        rolesArray = [...rolesArray, "collect-fee:receipt"];
                    }
                    Getdata.roles = rolesArray;
                    if(userType === 'staff-user') {
                        setstate(
                            {   
                                "first_name": Getdata.first_name,
                                "last_name": Getdata.last_name,
                                "mobile_number": Getdata.mobile_number,
                                "email_address": Getdata.email_address,
                                'employee_number':Getdata.employee_number,
                                "staff_type": Getdata.staff_type,
                                "branch_id":branchId,
                                "roles": Getdata.roles,
                            }
                        )
                    } else{
                        setstate({
                            "first_name": Getdata.first_name,
                            "last_name": Getdata.last_name,
                            "mobile_number": Getdata.mobile_number,
                            "email_address": Getdata.email_address,
                            'employee_number':Getdata.employee_number,
                            "roles": Getdata.roles,
                            "branch_id":id
                        })
                    }
                    seteditData(JSON.parse(JSON.stringify(Getdata)))
                }   
            } catch(erro){
                navigate('/404')
            }

        },
        [email_address],
    )
    
    useEffect(() => {
        if(edit)
            handleFetch()
    }, [handleFetch])
    
    const [state, setstate] = useState(initialState);
    const [submitSelected, setsubmitSelected] = useState(false)
    const handleInput=(e)=>{
        setToastErrorMessage('')
        const {id,value}=e.target
        setstate((prv)=>({
            ...prv,
            [id]:value
        }))
    }
    const handleValidation=(staffUser)=>{
        const arr=[]
        let mykeys = {}
        if(staffUser){
            mykeys={
                "first_name": "",
                "mobile_number": "",
                "email_address": "",
                "employee_number": '',
                "roles": [], 
                "staff_type" : ''
            }
        } else {
            mykeys={
                "first_name": "",
                "mobile_number": "",
                "email_address": "",
                "employee_number": '',
                "roles": []
            }
        }

        Object.keys(mykeys).map((item)=>{
            if(state[item]===''){
                arr.push(item)
            }
        })
        return arr?.length===0

    }
    const handleSubmit=async(e)=>{
        e.preventDefault()
        setcustomError([])
        const user = await CognitoCurrentData();
        setloading(true)
        setsubmitSelected(true);
        if(!handleValidation(userType === "staff-user")){
            setloading(false);
            setToastErrorMessage('Please fill in all the mandatory fields')

            return
        }
        if(state.roles?.length===0){
            setloading(false);
            setToastErrorMessage('Please fill in all the mandatory fields')
            return
        }
        const errors = [];  // Array to store validation errors
        if (validateEmail(state.email_address.trim())) {
            errors.push('email_address');
        }
        
        if (state.mobile_number?.length !== 10) {
            errors.push('mobile_number');
        }
        
        if (errors.length > 0) {
            setToastErrorMessage("Please enter valid details");
            let updatedCustomError = customError;
            
            // Add errors to customError array
            errors.forEach(error => {
                updatedCustomError = [...errors, error];
            });
            setcustomError(updatedCustomError);
            setloading(false);
            return;
        }
        try {
            const branchId = await GetBranchId()
            const {first_name,last_name,email_address,roles,mobile_number,employee_number,staff_type}=state;
            let body = 
            {
                "first_name": first_name,
                "mobile_number": mobile_number,
                "last_name": last_name,
                "user_type": userType,
                employee_number:employee_number,
                "institution_id": user['custom:institution_id'],
            }
            if(userType === "staff-user") {
                body.staff_type = staff_type;
                body.branch_id = branchId;
            } else {
                body.branch_id = id.split('*')[0];
            }
            let response
            if(edit){
                if(!compareArrays(roles,editData.roles)){ 
                    body.roles=roles
                }
                response = await dataService.PatchAPI(body,`users/${email_address}`);
            }else{
                body.roles=roles;
                body.email_address=email_address,

                response = await dataService.PostAPI(body,`users`);
            }
            setToastmessage(`${userType === 'staff-user' ? 'Employee' : 'Branch user'} ${edit?'updated':'added'} successfully`)
            if(userType === 'staff-user') {
                if(myRedirection?.redirect === 'fromViewScreen'){
                    navigate(`/employee-master/manage-employee/view-employee/${email_address}?${urlParams.toString()}`)
                } else {
                    navigate(`/employee-master/manage-employee?${urlParams.toString()}`)

                }
            } else {
                navigate(`/manage-branches/${id}?tab=branch-users?${urlParams.toString()}`)
            }
        } catch (error) {
            console.log("errorr", error)
            setloading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }

    }
    const handleSelection=(val)=>{
        setsubmitSelected(false);
        const copy = {...state};
        const idx = copy.roles.indexOf(val);
        if (idx !== -1) {
            copy.roles.splice(idx, 1);
        } else {
            copy.roles.push(val);
        }
        setstate(copy);
    }

    /**
     * The `cancelHandler` function navigates to different URLs based on the `userType` and `myRedirection`
     * conditions.
     */
    const cancelHandler = () => {
        const {email_address}=state;
        if(userType === 'staff-user'){
            if(myRedirection?.redirect === 'fromViewScreen'){
                navigate(`/employee-master/manage-employee/view-employee/${email_address}?${urlParams.toString()}`)
            } else {
                navigate(`/employee-master/manage-employee?${urlParams.toString()}`)
            }
        } else{ 
            navigate(`/manage-branches/${id}?${urlParams.toString()}`)
        }
    }

    return (
        <CardHeader noPadding>
            <form onSubmit={(e)=>handleSubmit(e)} noValidate>
                <div class="mainDataCntnrTop shadow-s13" style={{position: "sticky", position: -"webkit-sticky;"}}>
                    <h5 class="pageHeader adderror">{edit?'Edit':'Add'} {userType === "staff-user" ? 'Employee' : 'Branch User'}</h5>
                    <div class="flex items-center">
                        <button onClick={()=>cancelHandler()} type="button" class="cancl-btn" >
                            Cancel
                        </button>
                        <button  disabled={ loading || (edit&&Object.keys(editData)?.length===0)} type="submit" id="add_admin" class="actn-btn onboardInstitution" tabindex="0">
                            {!loading?edit?'Update':'Add':<span>{<Loader />}</span>}   
                        </button>
                    </div>
                </div>
                {edit && Object.keys(editData)?.length===0 && <CustomOverLay Active text="Loading..." classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}/>}
                <div class="mainDataCntnrPageDiv scrollBlue_thick">
                    <div class="w-[75%] mx-auto">
                        <div class="border border-[#D0D5DD] rounded p-3">
                            <div class="-mx-10 flex">
                                <div class="w-[50%] px-10">
                                    <div class="w-full">
                                        <div class="flex items-center mb-4">
                                            <label for="first_name" class="text-f7 font-normal text-[#031624] min-w-[145px] inline-flex">First Name</label>
                                            <Input
                                                type="text"
                                                state={state}
                                                id="first_name"
                                                handleInput={handleInput}
                                                maxLength={30}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                isMandatoryField = {true}
                                                text="First name is mandatory"
                                                placeholder ="Enter First Name"
                                            />
                                        </div>
                                        <div class="flex items-center mb-4">
                                            <label for="last_name" class="text-f7 font-normal text-[#031624] min-w-[145px] inline-flex">Last Name</label>
                                            <Input
                                                type="text"
                                                state={state}
                                                id="last_name"
                                                optional
                                                handleInput={handleInput}
                                                maxLength={30}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                text="Last name is mandatory"
                                                placeholder ="Enter Last Name"
                                            />                                    
                                        </div>
                                        <div class="flex items-center">
                                            <label for="employee_number" class="text-f7 font-normal text-[#031624] min-w-[145px] inline-flex">Employee Number</label>
                                            <Input
                                                type="text"
                                                state={state}
                                                id="employee_number"
                                                handleInput={handleInput}
                                                maxLength={30}
                                                submitSelected={submitSelected}
                                                setsubmitSelected={setsubmitSelected}
                                                text="Last name is mandatory"
                                                placeholder ="Enter Employee Number"
                                            />                                    
                                        </div>
                                    </div>
                                </div>
                                <div class="w-[50%] px-10">
                                    <div class="flex items-center mb-4">
                                        <label for="emailAddres" class="text-f7 font-normal text-[#031624] min-w-[125px] inline-flex">Email Address</label>
                                        <Input
                                            type="text"
                                            state={state}
                                            disable={edit?true:false}
                                            id="email_address"
                                            handleInput={handleInput}
                                            maxLength={70}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text="Email address is mandatory"
                                            placeholder ="Enter Email Address"
                                            customError={customError}
                                        />                                 
                                    </div>
                                    <div class="flex items-center mb-4">
                                        <label for="mobileNumber" class="text-f7 font-normal text-[#031624] min-w-[125px] inline-flex">Mobile Number</label>
                                        <Input
                                            type="number"
                                            state={state}
                                            id="mobile_number"
                                            handleInput={handleInput}
                                            maxLength={10}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            text="Mobile Number is mandatory"
                                            placeholder ="Enter Mobile Number"
                                            customError={customError}
                                        />                                   
                                    </div>
                                    {userType === "staff-user" &&
                                    <div class="flex items-center">
                                        <label for="bname" class="text-f7 font-normal text-[#031624] min-w-[125px] inline-flex">Type</label>
                                        <div ref={outsideClickRef} class="relative w-full" data-te-dropdown-ref>
                                            <button 
                                                onClick={() => setTypedropdown(!typeDropdown)} 
                                                class={`${submitSelected && state.staff_type === "" ? "redBorder" : ""} slct-inpt-fld transition duration-150 ease-in-out shadow-s12 error_border`}
                                                type="button" id="dropdownMenu_acdemic_year" data-te-dropdown-toggle-ref aria-expanded="false">
                                                <p class={`text-f7 font-normal ${state.staff_type === "" ? 'text-[#818E98]' : 'text-[#031624]'}`}>{state.staff_type === "" ? "Select Type" : state.staff_type}</p>
                                                <img src="/images/dropdown-icon.png" alt="icon" class="absolute top-[50%] -translate-y-[50%] dropdown-close right-3" />
                                            </button>
                                            {typeDropdown &&
                                            <ul class="slct_drp_dwn min-w-full [&[data-te-dropdown-show]]:block"
                                                aria-labelledby="dropdownMenu_acdemic_year"
                                                data-te-dropdown-menu-ref>
                                                <li class="max-h-[150px] overflow-auto scroll-bar">
                                                    <ul>
                                                        <li>
                                                            <a class="slct_drp_dwn_optn"
                                                                href="#" data-te-dropdown-item-ref
                                                                id = "staff_type"
                                                                onClick={()=>{setTypedropdown(false);
                                                                    setstate((prv)=>({
                                                                        ...prv,
                                                                        "staff_type":"Teaching"
                                                                    }))                                                            
                                                                }} 
                                                            >
                                                                Teaching
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a class="slct_drp_dwn_optn"
                                                                href="#" data-te-dropdown-item-ref
                                                                onClick={()=>{setTypedropdown(false);
                                                                    setstate((prv)=>({
                                                                        ...prv,
                                                                        "staff_type":"Non-Teaching"
                                                                    }))                                                            
                                                                }} 
                                                            >
                                                                Non-Teaching
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                            }
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <ManageRoles
                        userType={userType}
                        selected={state.roles} 
                        branch
                        handleSelection={handleSelection}
                        error={submitSelected}/>
                </div>
                
                {toastErrorMessage!=='' &&<Toast
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}
            </form> 
        </CardHeader> );
}

export default AddUser;
